<template>
  <div>
    <div class="max-w-lg mt-md p-md border-1 border-gray-400 sm:p-md">
      <div class="flex items-center flex-wrap gap-sm">
        <SloIcon name="TriangleExclamationSolidBorder" size="lg" />
        <p class="m-0 text-base"><strong>{{ 'WARNING California Residents' | t }}</strong></p>
        <button
          @click="showProp65Modal = true"
          class="p-0 bg-transparent c-blue-400 hover:c-blue-700"
        >
          {{ 'see Prop 65 warnings' | t }}
        </button>
      </div>
    </div>
    <transition name="fade-up">
      <SloModal
        v-if="showProp65Modal"
        :max-width="500"
        :form="false"
        @dismiss="showProp65Modal = false"
      >
        <template v-slot:title>
          <SloIcon name="TriangleExclamationSolidBorder" size="lg" />
          <span class="m-0"><strong>{{ 'WARNING California Residents' | t }}</strong></span>
        </template>
        <div>
          <p>{{ 'This product can expose you to chemicals including lead which is known to the State of California to cause cancer and birth defects or other reproductive harm.' | t }}</p>
          <p class="m-0">{{ 'For further details, please visit' | t }} <a href="https://www.p65warnings.ca.gov/" target="_blank">www.p65warnings.ca.gov</a>.</p>
        </div>
      </SloModal>
    </transition>
  </div>
</template>

<script>
import t from '../../js/main/i18n';
import SloIcon from './SloIcon.vue';
import SloModal from './SloModal.vue';

export default {
  name: 'SloProp65Warning',
  filters: {
    t
  },
  components: {
    SloIcon,
    SloModal
  },
  data() {
    return {
      showProp65Modal: false
    };
  }
};
</script>
